import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HeaderComponent,
  FooterComponent,
  UserAvatarComponent,
  ConfirmModalComponent,
  ReusableHeaderComponent, ReusableFooterComponent
} from './components';
import { RouterModule } from '@angular/router';
import { LoadSpinnerComponent } from './components/load-spinner/load-spinner.component';
import { BaseModalComponent } from './components/modal-components/base-modal/base-modal.component';
import { ModalShellComponent } from './components/modal-components/modal-shell/modal-shell.component';
import { ModalHeaderComponent } from './components/modal-components/modal-header/modal-header.component';
import { ModalBodyComponent } from './components/modal-components/modal-body/modal-body.component';
import { PrimaryButtonComponent } from './components/buttons/primary-button/primary-button.component';
import { SecondaryButtonComponent } from './components/buttons/secondary-button/secondary-button.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { AutofocusInputGroupComponent } from './components/form-components/autofocus-input-group/autofocus-input-group.component';
import { CheckboxComponent } from './components/form-components/checkbox/checkbox.component';
import { InputGroupComponent } from './components/form-components/input-group/input-group.component';
import { InputRequirementsListComponent } from './components/form-components/input-requirements-list/input-requirements-list.component';
import { ConfirmationModalComponent } from './components/modal-components/confirmation-modal/confirmation-modal.component';
import { ModalFooterComponent } from './components/modal-components/modal-footer/modal-footer.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { LogoComponent } from './components/svg-components/logo/logo.component';
import { TableCellComponent } from './components/tables/table-cell/table-cell.component';
import { TableHeaderComponent } from './components/tables/table-header/table-header.component';
import { TableComponent } from './components/tables/table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MainLayoutComponent} from "@app/layout/components/main-layout/main-layout.component";
import {BlankLayoutComponent} from "@app/layout/components/blank-layout/blank-layout.component";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    UserAvatarComponent,
    ConfirmModalComponent,
    LoadSpinnerComponent,
    BaseModalComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    SearchBarComponent,
    InputRequirementsListComponent,
    LogoComponent,
    ErrorMessageComponent,
    AutofocusInputGroupComponent,
    ConfirmationModalComponent,
    TableHeaderComponent,
    TableCellComponent,
    MainLayoutComponent,
    BlankLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ReusableHeaderComponent,
    ReusableFooterComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    UserAvatarComponent,
    ConfirmModalComponent,
    LoadSpinnerComponent,
    BaseModalComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    SearchBarComponent,
    InputRequirementsListComponent,
    LogoComponent,
    ErrorMessageComponent,
    AutofocusInputGroupComponent,
    ConfirmationModalComponent,
    TableHeaderComponent,
    TableCellComponent,
    MainLayoutComponent,
    BlankLayoutComponent
  ]
})
export class LayoutModule { }
